import type { PageState, ServerMessage } from '@roll1/shared';

/** Update the page cache even when another page is currently displayed. */
export function applyPageEntityMessage(page: PageState, msg: ServerMessage): void {
  const upsert = <T extends { id: string }>(items: T[], item: T): T[] => [...items.filter(x => x.id !== item.id), item];
  switch (msg.type) {
    case 'map-object:created': page.mapObjects = upsert(page.mapObjects ?? [], msg.mapObject); break;
    case 'map-object:updated': page.mapObjects = (page.mapObjects ?? []).map(o => o.id === msg.objectId ? { ...o, ...msg.changes } : o); break;
    case 'map-object:deleted': page.mapObjects = (page.mapObjects ?? []).filter(o => o.id !== msg.objectId); break;
    case 'map-object:reordered': {
      const objects = new Map((page.mapObjects ?? []).map(o => [o.id, o]));
      page.mapObjects = msg.objectIds.flatMap((id, sortOrder) => { const o = objects.get(id); return o ? [{ ...o, sortOrder }] : []; });
      break;
    }
    case 'wall:created': page.walls = upsert(page.walls ?? [], msg.wall); break;
    case 'walls:created': for (const wall of msg.walls) page.walls = upsert(page.walls ?? [], wall); break;
    case 'wall:updated': page.walls = upsert(page.walls ?? [], msg.wall); break;
    case 'wall:deleted': page.walls = (page.walls ?? []).filter(w => w.id !== msg.wallId); break;
    case 'wall:auto-synced': page.walls = [...(page.walls ?? []).filter(w => !msg.removed.includes(w.id) && !msg.added.some(a => a.id === w.id)), ...msg.added]; break;
    case 'door:toggled': page.walls = upsert(page.walls ?? [], msg.wall); break;
    case 'annotation:created':
    case 'annotation:updated': page.annotations = upsert(page.annotations ?? [], msg.annotation); break;
    case 'annotation:deleted': page.annotations = (page.annotations ?? []).filter(a => a.id !== msg.annotationId); break;
    case 'trigger:created': page.triggers = upsert(page.triggers ?? [], msg.trigger); break;
    case 'trigger:deleted': page.triggers = (page.triggers ?? []).filter(t => t.id !== msg.triggerId); break;
    case 'trigger:toggled': page.triggers = (page.triggers ?? []).map(t => t.id === msg.triggerId ? { ...t, enabled: msg.enabled } : t); break;
    case 'trigger:fired': page.triggers = (page.triggers ?? []).map(t => t.id === msg.triggerId && t.oneShot ? { ...t, enabled: false } : t); break;
  }
}
